/**
 * Updates Page JavaScript
 * 
 * JavaScript functionality for the updates/post grid page
 */

// Import the main app styles to include post-grid styles
import '../scss/app.scss';

// Initialize any updates-specific functionality
document.addEventListener('DOMContentLoaded', function() {
    
    // Post grid functionality can be added here
    // For example: category filtering, load more posts, search, etc.
    
    const postGrid = document.getElementById('updates-grid');
    if (postGrid) {
        
        const grid = document.getElementById('updates-grid');
        const toggleBtn = document.querySelector('.categories-toggle-btn');
        const overlay  = document.querySelector('.categories-overlay');
        const sidebar  = document.getElementById('updates-categories-sidebar');

        if (toggleBtn && sidebar && overlay && grid) {
          toggleBtn.addEventListener('click', () => {
            const isOpen = grid.classList.toggle('sidebar-open');
            toggleBtn.setAttribute('aria-expanded', isOpen);
          });

          overlay.addEventListener('click', () => {
            grid.classList.remove('sidebar-open');
            toggleBtn.setAttribute('aria-expanded', 'false');
          });
        }
        
        // Add any interactive functionality here
        initializePostGrid();
    }
});

/**
 * Initialize post grid functionality
 */
function initializePostGrid() {
    // Example: Add smooth scrolling to pagination links
    const paginationLinks = document.querySelectorAll('.pagination-link');
    
    paginationLinks.forEach(link => {
        link.addEventListener('click', function(e) {
            // Smooth scroll to top of grid on pagination
            const postGrid = document.getElementById('updates-grid');
            if (postGrid) {
                setTimeout(() => {
                    postGrid.scrollIntoView({ 
                        behavior: 'smooth',
                        block: 'start'
                    });
                }, 100);
            }
        });
    });
    
    // Example: Category sidebar functionality could go here
    const categorySidebar = document.querySelector('.categories-sidebar');
    if (categorySidebar) {
        console.log('Categories sidebar found');
        // Add category filtering functionality here if needed
    }
}

// Export functions for potential use by other scripts
export { initializePostGrid };